import { Injectable } from '@angular/core';
import { HttpService } from 'src/app/services/http/http.service';

import { Path } from '../../../utils/constant/paths';

@Injectable({
  providedIn: 'root'
})
export class QuantityPurchasedByDoctorService {

  constructor(
    private http: HttpService,
  ) { }

  filter(data?: any) {
    return this.http.post(Path.QUANTITY_PURCHASE_REPORT.FILTER, data);
  }

  generate(data?: any) {
    return this.http.post(Path.QUANTITY_PURCHASE_REPORT.GENERATE, data);
  }

  getList(data?: any) {
    return this.http.post(Path.QUANTITY_PURCHASE_REPORT.GET_LIST, data)
  }

}